import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { Nav_Interface } from 'src/app/Interface/Nav_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TicketCategoryService {

  constructor(private http:HttpClient) { }


  GetRecord():Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/TicketCategory").pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  GetActiveList():Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/TicketCategory/GetActiveList").pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  GetTicketCategoryUser(
    id:number,):Observable<Array<Nav_Interface>>{
    return this.http.get(environment.BaseUrl
      + "Daro/TicketCategory/GetTicketCategoryUser?id="+id).pipe(
      map(data=>{
        return data as Array<Nav_Interface>
      })
    )
  }

  GetSingle(id:Number):Observable<General_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/TicketCategory/GetSingle?id="+id).pipe(
      map(data=>{
        return data as General_Interface
      })
    )
  }

  AddTicketCategory(model: General_Interface):Observable<General_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      del:false,
      username:'',
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/TicketCategory/Add",body,{headers}).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

  EditTicketCategory(model: General_Interface):Observable<General_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      del:false,
      username:'',
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/TicketCategory/Edit",body,{headers}).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

  DeleteTicketCategory(id:number):Observable<General_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/TicketCategory/Delete?id="+id).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

  }
